"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const checkRemainingBallOptions = (currentBallBitwise) => {
    let options = {
        dot: true,
        runs: true,
        wide: true,
        noBall: true,
        bye: true,
        legBye: true,
        wicket: true,
    };
    if (currentBallBitwise === null)
        return options;
    options.dot = false;
    if (currentBallBitwise & 1 || currentBallBitwise === 0) {
        options.runs = false;
    }
    if (currentBallBitwise & 2 || currentBallBitwise & 4 || currentBallBitwise === 0) {
        options.wide = false;
        options.noBall = false;
    }
    if (currentBallBitwise & 2 || currentBallBitwise & 8 || currentBallBitwise & 16 || currentBallBitwise === 0) {
        options.wide = false;
        options.bye = false;
        options.legBye = false;
    }
    if (currentBallBitwise & 32 || currentBallBitwise === 0) {
        options.wicket = false;
    }
    return options;
};
exports.default = checkRemainingBallOptions;
//# sourceMappingURL=checkRemainingBallOptions.js.map